
export const SET_PARTS = 'SET_PARTS'
export const REMOVE_PART = 'REMOVE_PART'
export const SET_TP_PARAMS = 'SET_TP_PARAMS'
export const SET_PART_PARAMS = 'SET_PART_PARAMS'
export const SET_MODELS = 'SET_MODELS'
export const SET_MODIFICATIONS = 'SET_MODIFICATIONS'
export const SET_ENGINES = 'SET_ENGINES'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_CURRENT_PART = 'SET_CURRENT_PART'
export const SET_META = 'SET_META'
export const EDIT_PART = 'EDIT_PART'
export const SET_SELECTED_PARTS = 'SET_SELECTED_PARTS'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const SET_LOADING = 'SET_LOADING'
export const SET_LOGS = 'SET_LOGS'
export const SET_SHOWING = 'SET_SHOWING'
export const SET_PART_WHEEL_SPECIFICATIONS = 'SET_PART_WHEEL_SPECIFICATIONS'
export const SET_WHEEL_SPECIFICATIONS = 'SET_WHEEL_SPECIFICATIONS'
export const SET_PARTS_STATISTICS = 'SET_PARTS_STATISTICS'
export const SET_PROCESS_PICTURES_CALLBACK = 'SET_PROCESS_PICTURES_CALLBACK'
